// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'farm-solid';

export const Component = () => (
  <path d='m4.55 23.6 2.3-2.683L9.147 23.6H4.55Zm-.623-6.131v5.364l2.3-2.682-2.3-2.682Zm2.921 1.964 2.3-2.682H4.55l2.3 2.682h-.002Zm0-13.314L.478 10.14c-.334.144-.478.432-.478.814V23.6h2.921v-7.376c0-.335.192-.478.527-.478h6.848c.335 0 .479.143.479.478V23.6h2.97V10.43L6.848 6.12ZM7.52 20.15l2.299 2.682v-5.364l-2.3 2.682ZM21.84 2h-.527c-.72 0-1.341.24-1.868.766-.528.528-.815 1.198-.815 1.916v1.245h5.891V4.682c0-.719-.239-1.389-.766-1.916C23.227 2.24 22.557 2 21.839 2Zm-3.21 4.933v16.666h5.891v-4.885h-1.963V17.71h1.963v-1.964h-1.963v-.957h1.963v-1.964h-1.963V11.82h1.963V9.855h-1.963v-.957h1.963V6.934h-5.89v-.001Zm-3.927 3.927V23.6h2.97V10.86h-2.97ZM8.43 5.927l6.274 3.927h2.97V5.927H8.429Z' />
);

export const viewBox = '0 0 25 25';
